<template>
  <div
    id="alertModal"
    ref="alertModalRef"
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ title }}
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="hide"
          />
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="hide"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Modal from "bootstrap/js/dist/modal";

const title = ref("");
const message = ref("");
const alertModalRef = ref<HTMLElement | null>(null);

let modal: Modal | null = null;

function showAlertModal(newTitle: string, newMsg: string) {
  title.value = newTitle;
  message.value = newMsg;
  if (!modal && alertModalRef.value) {
    modal = new Modal(alertModalRef.value, { backdrop: "static" });
  }
  modal?.show();
}

function hide() {
  modal?.hide();
}

defineExpose({
  showAlertModal
});
</script>
